import { reactive } from 'vue';
import type { ProfileRecord } from './registry';

/**
 * The open profile (docs/TZ-PROFILES.md): set once at start, before the app reads any data.
 * `guest` — the browser keeps nothing (no IndexedDB): a profile in memory, gone with the tab.
 * `locked` — the PIN screen covers the app (by hand or after the idle time).
 */
export const profileState = reactive({
  current: null as ProfileRecord | null,
  guest: false,
  locked: false,
});

export function currentProfileId(): string | null {
  return profileState.current?.id ?? null;
}
